<template>
<section class="section contact">
    <div class="container">
        <header class="section-header">
            <h2 class="title is-2">{{section_data.title}}</h2>
            <span><i></i><i></i><i></i></span>
        </header>
        <form class="contact-form" method="post" @submit.prevent="submit">
            <fieldset :disabled="is_loading">
                <div class="columns is-variable is-4">
                    <div class="column">
                        <input type="text" required class="is-large input" placeholder="Name (*)" v-model="name" />
                    </div>
                    <div class="column">
                        <input type="email" required class="is-large input" placeholder="Email (*)" v-model="email" />
                    </div>
                </div>
                <div class="columns is-variable is-8">
                    <div class="column">
                        <input type="text" required class="is-large input" placeholder="Subject (*)" v-model="title" />
                    </div>
                </div>
                <div class="columns is-variable is-8">
                    <div class="column">
                        <textarea class="textarea is-large" required rows="6" placeholder="Message (*)" v-model="content"></textarea>
                    </div>
                </div>
                <div class="columns is-variable is-8 is-multiline">
                    <div class="column is-12" v-if="recap_err">
                        <div class="notification is-danger">
                            {{recap_err}}
                        </div>
                    </div>
                    <div class="column is-12 has-text-centered action">
                        <vue-recaptcha
                            v-if="section_data.site_key"
                            ref="recaptcha"
                            @verify="verify"
                            @expired="expired"
                            @error="error"
                            :sitekey="section_data.site_key"
                            :loadRecaptchaScript="true">
                            <button :class="['is-large button is-black', {'is-loading': is_loading}]" type="submit">Send Message</button>
                        </vue-recaptcha>
                        <p class="help" v-if="msg">{{msg}}</p>
                    </div>
                </div>
            </fieldset>
        </form>
    </div>
</section>
</template>

<script>
import VueRecaptcha from 'vue-recaptcha';
import PosHandler from '../../mixins/PosHandler';
export default {
    name        :   'ContactSection',
    props       :   ['section_data', 'is_mobile'],
    components  :   { VueRecaptcha },
    mixins      :   [ PosHandler ],
    data()
    {
        return {
            is_loading  :   false,
            email       :   null,
            name        :   null,
            title       :   null,
            content     :   null,
            recap_resp  :   null,
            recap_err   :   null,
            msg         :   null
        };
    },
    methods :   {
        reset() {
            this.is_loading =   false;
            this.email      =   null;
            this.name       =   null;
            this.title      =   null;
            this.content    =   null;
            this.recap_resp =   null;
            this.recap_err  =   null;
            this.$refs.recaptcha.reset();
        },
        expired() {
            this.recap_resp =   null;
            this.recap_err  =   null;
        },
        verify(resp) {
            if (this.is_loading) return false;

            if (!this.name || !this.email || !this.title || !this.content) {
                this.$refs.recaptcha.reset();
                alert('Please fill all fields :)');
                return false;
            }

            this.is_loading =   true;
            this.recap_resp =   resp;
            this.msg        =   null;
            this.recap_err  =   null;

            this.submit();
        },
        error()
        {
            this.is_loading =   false;
        },
        submit() {
            if (!this.recap_resp) {
                this.recap_err  =   'Please prove you are not a robot!';
                return false;
            }

            let me          =   this,
                data        =   new FormData();

            data.append('title', this.title);
            data.append('content', this.content);
            data.append('name', this.name);
            data.append('email', this.email);
            data.append('recap_resp', this.recap_resp);

            axios.defaults.headers.common['X-CSRF-TOKEN'] = csrf;

            axios.post(
                base_url + endpoints.contact,
                data
            ).then((resp) => {
                this.msg        =   resp.data.message;
                delete axios.defaults.headers.common['X-CSRF-TOKEN'];
                me.reset();
            }).catch((error) => {
                this.$refs.recaptcha.reset();
                me.is_loading   =   false;
                this.recap_err  =   error.response.data.message;
            });
        }
    }
}
</script>



// WEBPACK FOOTER //
// src/components/blocks/sections/ContactSection.vue